import { useQuery } from 'react-query';
import axios from 'axios';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

// item 355a — one row per chat thread the caller is BEHIND on, server-computed
// (GET Chat/UnreadSummary). kind routes the bell's deep link.
export interface UnreadThread {
  threadKey: string | null;
  kind: 'accountant' | 'team' | 'project' | 'helpdesk';
  label: string;
  unread: number;
  latestDate: string;
  projectId?: string | null; // item 398 — help desks deep-link to their project
}

// item 355a — the notification bell's single poll. 15s: fast enough to feel live,
// far lighter than the per-thread 5s message polls (which only run on open panels).
const useUnreadSummary = (enabled: boolean) => {
  const query = useQuery<UnreadThread[]>(
    'unreadSummary',
    async () => {
      const { data } = await axios.get(`${apiUrl()}Chat/UnreadSummary`);
      return Array.isArray(data) ? data : [];
    },
    { enabled, refetchInterval: 30_000, refetchOnWindowFocus: true }, // item 966 — polling diet
  );
  const threads = query.data ?? [];
  return {
    threads,
    totalUnread: threads.reduce((sum, t) => sum + t.unread, 0),
    isLoading: query.isLoading,
  };
};

export default useUnreadSummary;
